import React, { FC, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { DeleteResourcesDialog } from "../DeleteResources/components/DeleteResourcesDialog";

import { MAX_TOOLTIP_ITEMS_LENGTH } from "./const";
import { layerWithTableRefs } from "../../../resources/layers";
import { useDialogInfo } from "../../../hooks/useDialogs";
import { useNotification } from "../../../hooks/notifications/useNotification";

export const DeleteLayer: FC = () => {
  const { t } = useTranslation("dialogs");
  const {
    resources: [layerName],
    closeDialog,
  } = useDialogInfo(true);

  const {
    data,
    loading,
    error: layerInfoFetchError,
  } = layerWithTableRefs.use({
    input: { name: layerName, extendedRefsLimit: MAX_TOOLTIP_ITEMS_LENGTH },
  });

  const resources = useMemo(() => {
    if (!data) {
      return { layers: [], deps: { tables: [] } };
    }

    return { layers: [data.layer], deps: { tables: [data.table] } };
  }, [data]);

  useNotification(layerInfoFetchError, {
    title: t("deleteLayer.fetchError"),
    error: true,
  });

  useEffect(() => {
    if (layerInfoFetchError) {
      closeDialog();
    }
  }, [layerInfoFetchError]);

  return <DeleteResourcesDialog resources={resources} loading={loading} closeDialogOnDelete />;
};
